import React from 'react'
import { useSupplierProfile } from 'hooks/useSupplierProfile'
import { ProductForm } from './ProductForm'

export const ShopifyProducts = ({ row }) => {
    const { isShopifyConnected } = useSupplierProfile()

    return isShopifyConnected
        ? row?.original?.productsV2.map(product => <ProductForm key={product.productId} {...{ product, resourceId: row.original.resourceId }} />)
        : null
}
